export const environment = {
  production: true,
  // NEXT_PUBLIC_API_BASE_URL: 'http://localhost:5000/api/v1/',
  // NEXT_PUBLIC_API_BASE_URL: 'https://v2-beta-api.bhakts.com/api/v1/',
  NEXT_PUBLIC_API_BASE_URL: 'https://v2-api.bhakts.com/api/v1/',
  STORAGE_KEY: 'bhakts',
  authKey: 'bhakts_admin_token',
  s3BaseUrl: 'https://bhakts.s3.us-east-2.amazonaws.com/',
  activeTab: 'BhAcTab'
};
